import { BuildingViewerRegionData } from '../../../../Content';

export interface Props {
  region: BuildingViewerRegionData;
  isActive: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

export const PickableRegion: React.FC<Props> = (props) => {
  return (
    <div
      className={`building-viewer-region${props.isActive ? '-active' : ''}`}
      style={{
        position: 'absolute',
        left: `${props.region.x}%`,
        top: `${props.region.y}%`,
        width: `${props.region.w}%`,
        height: `${props.region.h}%`,
      }}
      onClick={props.onClick}
    />
  );
};
